import axios from 'axios';
import { createContext, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    ADD_COMMENTS_URL,
    ADD_MLT_USERS,
    ADD_USERS,
    EVENTS_BASE_URL,
    FAMILY_USERS,
    GUEST_ADMIN,
    GUEST_MLT,
    GET_HISTORY_URL,
    MLT_USERS,
    PROCESS_INVITATION,
    PROCESS_MLT_INVITATION,
    REJECT_REQUEST,
    REMOVE_MLT_USERS,
    REMOVE_USERS,
    SEND_TO_REQUESTOR,
    MARK_AS_COMPLETE,
    EVENT_ATTACHMENTS_URL,
    EVENT_BRIEFS_URL,
    VALIDATE_OPEN_EVENT
} from './ApiDetails.js';
import { confirm } from '../utilities/Confirm.tsx';
import { notifyError } from '../utilities/Notification.tsx';

const FormContext = createContext({});
export const FormProvider = ({ children }) => {

    const navigate = useNavigate();
    const [associateAtEvent, setassociateAtEvent] = useState([])
    const [selectedAssociates, setSelectedAssociates] = useState(new Set());
    const [files, setFiles] = useState([]);
    const title = {
        0: 'Event',
        1: 'Schedule',
        2: 'Guests',
        3: 'History',
        4: 'Summary'
    }
    const hiddenUploadBriefFileInput = useRef(null);
    const hiddenAttachmentFileInput = useRef(null);
    const [errors, setErrors] = useState({})
    const [isCoverImageUploaded, setIsCoverImageUploaded] = useState(false);
    const [attachments, setAttachments] = useState([])
    const [briefs, setBriefs] = useState([]);
    const [page, setPage] = useState(0)
    const [showModal, setShowModal] = useState(false);
    const [showConfirmationModalEventValidation, setShowConfirmationModalEventValidation] = useState(false);
    const [showConfirmationModalDeleteUpload, setShowConfirmationModalDeleteUpload] = useState(false);
    const [user, setUser] = useState('')
    const [editable, setEditable] = useState(false)
    const [isRejected, setIsRejected] = useState(false)
    const hiddenUploadImageFileInput = useRef(null);
    const [familyUsers, setFamilyUsers] = useState([])
    const [mltUsers, setMLTUsers] = useState([])
    const [comments, setComments] = useState({
        EventSection: '',
        DraftSection: '',
        VisitSection: '',
        BriefSection: '',
        AttachmentSection: '',
        HistorySection: ''
    })
    const [eventFormData, setEventFormData] = useState({
        // Initialize your form data state here
        requestedBy: '',
        eventTitle: '',
        associateSegment: '',
        email: '',
        phone: '',
        phoneCode: '',
        eventDate: '',
        siteCode: '',
        countryName: '',
        stateName: '',
        cityName: '',
        eventVenueName: '',
        eventAddress: '',
        eventType: '',
        eventStatus: 'Draft',
        eventFormat: '',
        totalAttendees: 0,
        petcareAttendees: 0,
        schedule: {
            visitSummary: '',
            draftItinerary: ''
        },
        maxFamilyNum: false,
        familyNum: 1,
        specificFamilyMem: false,
        nameOfMem: '',
        mem: [],
        IsScheduleChange: false,
        lastVisit: '',
        associates: '',
        IsImageCover: false,
        eventId: 0,
        eventEndDate: '',
        mltEvent: false,
        MaxMLTNum: false,
        specificMLTMem: false,
        NameOfMLT: '',
        mlt: [],
        mltNum: 0,
    });

    const [guestDetails, setGuestDetails] = useState({
        guests: [],
        SeatsRequired: 0,
        UnderReview: 0,
        Confirmed: 0,
        MaxUsersCount: 0,
        IsMaxCount: false
    })

    const [showPopup, setShowPopup] = useState(eventFormData.eventStatus !== 'Open event')
    const [modalGuest, setModalGuest] = useState();


    // TODO: Check if cover image works
    const handleChange = (e) => {
        e.preventDefault();
        var name = e.target.name;
        if (name === "imageFile") {
            setEventFormData({ ...eventFormData, IsImageCover: false });
            const bgUrl = URL.createObjectURL(e.target.files[0]);
            document.getElementById("hdrDiv").style.backgroundImage = "url(" + bgUrl + ")";

            name = "IsImageCover";
        }
    };


    const handleUploadImageClick = () => {
        hiddenUploadImageFileInput.current.click();
    };

    const handlepageChange = (val) => {

        setPage(val);
        if (val === 1) {
            onScheduleLoad()
        }
        if (val === 3) {
            onHistoryLoad()
        }
    }

    const handleEmailValidation = (e) => {
        const email = e.target.value;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (email && !emailRegex.test(email)) {
            // Handle invalid email
            setErrors({ ...errors, coHostEmail: 'Please enter a valid email address' });
        } else {
            // Clear the error if email is valid or empty
            setErrors({ ...errors, coHostEmail: '' });
        }
    };

    function handleValidation() {
        // Reset errors
        let newErrors = {};

        // Basic validations
        if (!eventFormData.associateSegment) newErrors.associateSegment = 'Associate segment is required';
        if (!eventFormData.phone) newErrors.phone = 'Phone is required';
        if (!eventFormData.eventDate) newErrors.eventDate = 'Event date is required';
        if (!eventFormData.eventEndDate) newErrors.eventEndDate = 'Event date is required';
        if (!isEventOffSite && !eventFormData.siteCode) newErrors.siteCode = 'Site code is required';
        if (!eventFormData.eventType) newErrors.eventType = 'Event type is required';
        if (!eventFormData.eventFormat) newErrors.eventFormat = 'Event format is required';
        if (!eventFormData.lastVisit) newErrors.lastVisit = 'LastVisit is required';
        if (!eventFormData.totalAttendees) newErrors.totalAttendees = 'Total attendees is required';
        if (!eventFormData.mltEvent && (eventFormData.familyNum === 0)) {
            newErrors.familyNum = 'Please specify the minimum family number';
        }
        //mlt 
        if (eventFormData.mltEvent && (eventFormData.mltNum === 0)) {
            newErrors.mltNum = 'Please specify the minimum MLT number';
        }
        if (eventFormData.eventFormat === "Other" && !eventFormData.otherEventFormat) {
            newErrors.otherEventFormat = 'Please specify the other event format';
        }
        if (eventFormData.eventType === "Other" && !eventFormData.otherEventType) {
            newErrors.otherEventType = 'Please specify the other event type';
        }

        // Email validation
        const emailPattern = /^\S+@\S+\.\S+$/;
        if (eventFormData.email && !emailPattern.test(eventFormData.email)) {
            newErrors.email = 'Please enter a valid email address';
        }

        // Phone validation
        const phonePattern = /^[0-9]+$/;
        if (eventFormData.phone && !phonePattern.test(eventFormData.phone)) {
            newErrors.phone = 'Please enter a valid phone number';
        }

        if (isEventOffSite) {
            eventFormData.eventAddress = searchAddress;
            if (!eventFormData.eventAddress) {
                newErrors.eventAddress = 'Please enter an address for the external event';
            }
        }


        const associateMapping = {
          "Corporate": "marsCorporateAttendees",
          "Food & Nutrition & Multisales": "marsFoodNutritionAttendees",
          "Mars Global Services": "marsGlobalServicesAttendees",
          "Multisales": "marsMultisalesAttendees",
          "Snacking": "marsSnackingAttendees",
          "Petcare": "marPetCareAttendees",
          "Veterinary Health": "marsVeterinaryHealthAttendees",
        };
        associateAtEvent.forEach(element => {
            const apiName = associateMapping[element]; // Get the API name
            if ((selectedAssociates.has(element)) && !eventFormData[apiName]) {
                newErrors[apiName] = 'Please enter a number of attendees';
            }
            if (!selectedAssociates.has(element)) eventFormData[apiName] = null;
        });

        setErrors(newErrors);

        // If no errors, proceed with form submission
        if (Object.keys(newErrors).length > 0) {
            alert("Check for validation errors before submitting");
            return false;
        }

        return true;
    }

    const handleScheduleItenaryChange = (e) => {
        eventFormData.schedule.draftItinerary = e;
        eventFormData.IsScheduleChange = true;
    };

    const getEventById = async (eventID) => {
        try {
            const response = await axios.get(`${EVENTS_BASE_URL}/${eventID}`);
            const data = response.data;
            if (data != null) {
                const updatedEventFormData = { ...eventFormData };
                updatedEventFormData.id = data.id;
                updatedEventFormData.eventId = data.eventId;
                updatedEventFormData.requestedBy = data.requestedBy;
                updatedEventFormData.eventTitle = data.eventTitle;
                updatedEventFormData.eventStatus = data.eventStatus;
                updatedEventFormData.associateSegment = data.associateSegment;
                updatedEventFormData.countryName = data.countryName;
                updatedEventFormData.stateName = data.stateName;
                updatedEventFormData.cityName = data.cityName;
                updatedEventFormData.email = data.email;
                updatedEventFormData.phone = data.phone;
                updatedEventFormData.phoneCode = data.phoneCode;
                updatedEventFormData.eventDate = data.eventDate;
                updatedEventFormData.eventEndDate = data.eventEndDate;
                updatedEventFormData.siteCode = data.siteCode;
                updatedEventFormData.otherSiteCode = data.otherSiteCode;
                updatedEventFormData.lastVisit = data.lastVisit;
                updatedEventFormData.isDateFlexible = data.isDateFlexible;
                updatedEventFormData.mltEvent = data.mltEvent;
                updatedEventFormData.eventVenueName = data.eventVenueName;
                updatedEventFormData.eventAddress = data.eventAddress;
                updatedEventFormData.eventType = data.eventType;
                updatedEventFormData.eventFormat = data.eventFormat;

                if (data.siteCode === "OFF") {
                    setSearchAddress(data.eventAddress);
                }

                updatedEventFormData.otherEventType = data.otherEventType;
                updatedEventFormData.otherEventFormat = data.otherEventFormat;

                updatedEventFormData.eventCoHost = data.eventCoHost;
                updatedEventFormData.coHostEmail = data.coHostEmail;
                updatedEventFormData.maxFamilyNum = data.maxFamilyNum;
                updatedEventFormData.familyNum = data.familyNum;
                updatedEventFormData.specificFamilyMem = data.specificFamilyMem;
                updatedEventFormData.nameOfMem = data.nameOfMem;
                updatedEventFormData.mem = data.mem;
                updatedEventFormData.associates = data.associates;
                updatedEventFormData.petcareAttendees = data.petcareAttendees;
                updatedEventFormData.marPetCareAttendees = data.marPetCareAttendees;
                updatedEventFormData.marsCorporateAttendees = data.marsCorporateAttendees;
                updatedEventFormData.marsFoodNutritionAttendees = data.marsFoodNutritionAttendees;
                updatedEventFormData.marsGlobalServicesAttendees = data.marsGlobalServicesAttendees;
                updatedEventFormData.marsMultisalesAttendees = data.marsMultisalesAttendees;
                updatedEventFormData.marsSnackingAttendees = data.marsSnackingAttendees;
                updatedEventFormData.marsVeterinaryHealthAttendees = data.marsVeterinaryHealthAttendees;

                if (updatedEventFormData.mltEvent) {
                    updatedEventFormData.MaxMLTNum = data.maxMLTNum;
                    updatedEventFormData.mltNum = data.mltNum;
                    updatedEventFormData.specificMLTMem = data.specificMLTMem;
                    updatedEventFormData.NameOfMLT = data.nameOfMLT;
                    updatedEventFormData.mlt = data.mlt;
                } else {
                    // Reset to null or default values when mltEvent is false
                    updatedEventFormData.MaxMLTNum = false;
                    updatedEventFormData.mltNum = 0;
                    updatedEventFormData.specificMLTMem = false;
                    updatedEventFormData.NameOfMLT = '';
                    updatedEventFormData.mlt = [];
                }


                if (data.schedule != null) {
                    const sch = {};
                    sch.visitSummary = data.schedule.visitSummary || "";
                    sch.draftItinerary = data.schedule.draftItinerary || "";
                    updatedEventFormData.schedule = sch;
                }

                const initialAssociatesSet = new Set(updatedEventFormData.associates.split(',').map(item => item.trim()));
                setSelectedAssociates(initialAssociatesSet);

                updatedEventFormData.totalAttendees = data.totalAttendees;

                statusHiglight(data.eventStatus);
                if (isRejected) {
                    setRejectEventPage()
                }

                handleGuestData();

                setEventFormData(updatedEventFormData);

                getFamilyUserList();
                getmltsuerlist();
            }
        } catch (error) {
            console.error('Error getting event data', error);
        }
    };

    const handleMLTEventChange = (e) => {
        const { checked } = e.target;
        setEventFormData((prevState) => ({
            ...prevState,
            mltEvent: checked,
        }));
    };

    const handleGuestData = async () => {
        if (eventFormData.eventId !== 0) {
            try {
                if (eventFormData.mltEvent != true) {

                    await axios.get(`${EVENTS_BASE_URL}/${eventFormData.eventId}/${GUEST_ADMIN}`)
                        .then(response => {
                            if (response.data.guests !== null) {
                                var guestDetails = {}
                                guestDetails.SeatsRequired = response.data.seatsRequired
                                guestDetails.UnderReview = response.data.underReview
                                guestDetails.Confirmed = response.data.confirmed
                                guestDetails.IsMaxCount = false // eventFormData.maxFamilyNum
                                guestDetails.MaxUsersCount = eventFormData.familyNum
                                var guestList = []
                                response.data.guests.forEach(element => {
                                    guestList.push({
                                        'id': element.userId,
                                        'name': element.fullname,
                                        'status': element.status
                                    })
                                })
                                guestDetails.guests = guestList
                                setGuestDetails(guestDetails)
                            }
                        })
                }
                else {
                    await axios.get(`${EVENTS_BASE_URL}/${eventFormData.eventId}/${GUEST_MLT}`)
                        .then(response => {
                            if (response.data.guests !== null) {
                                var guestDetails = {}
                                guestDetails.SeatsRequired = response.data.seatsRequired
                                guestDetails.UnderReview = response.data.underReview
                                guestDetails.Confirmed = response.data.confirmed
                                guestDetails.IsMaxCount = false // eventFormData.MaxMLTNum
                                guestDetails.MaxUsersCount = eventFormData.mltNum
                                var guestList = []
                                response.data.guests.forEach(element => {
                                    guestList.push({
                                        'id': element.userId,
                                        'name': element.fullname,
                                        'status': element.status
                                    })
                                })
                                guestDetails.guests = guestList
                                setGuestDetails(guestDetails)
                            }
                        })
                }
            } catch (error) {
                console.error('Error get guest data', error);
            }
        }

    }

    const handleBriefUpload = (e) => {
        if (eventFormData.eventId === 0)
            alert("The event being created was never saved, please save it before uploading the brief.");
        else {
            let briefData = new FormData();
            briefData.append("File", e.target.files[0]);
            briefData.append("EventId", eventFormData.eventId);
            const headers = {
                'Content-Type': 'multipart/form-data'
            }
            axios.post(EVENT_BRIEFS_URL, briefData, { headers })
                .then(response => {
                    alert("Brief Updated");
                    setBriefs([...briefs, response.data]);
                })
                .catch(error => {
                    console.error('Error updating the details: ', error);
                    alert("Error uploading brief");
                });

        }

    };

    const handleUploadBriefFileClick = () => {
        if (eventFormData.eventId === 0)
            alert("The event being created was never saved, please save it before uploading the brief.");
        else
            hiddenUploadBriefFileInput.current.click();
    };

    const handleUploadAttachmentClick = () => {
        if (eventFormData.eventId === 0)
            alert("The event being created was never saved, please save it before uploading attachements.");
        else
            hiddenAttachmentFileInput.current.click();
    };

    const handleAttachmentsUpload = (e) => {
        if (eventFormData.eventId === 0)
            alert("The event being created was never saved, please save it before uploading attachments.");
        else {
            let attachData = new FormData();
            attachData.append("File", e.target.files[0]);
            attachData.append("EventId", eventFormData.eventId);//eventFormData.eventId
            const headers = {
                'Content-Type': 'multipart/form-data'
            }

            axios.post(EVENT_ATTACHMENTS_URL, attachData, { headers })
                .then(response => {
                    alert("Attachment Updated");
                    setAttachments([...attachments, response.data]);
                })
                .catch(error => {
                    console.error('Error updating the details: ', error);
                    alert("Error uploading attachment");
                });
        }
    };

    const handleBriefDelete = async (e, eventId, name) => {
        e.preventDefault();

        const confirmResult = await confirm({ title: 'Confirm', message: 'Are you sure you want to delete this brief file?' });
        if (confirmResult) {
            try {
                await axios.delete(`${EVENT_BRIEFS_URL}/${eventId}/${encodeURIComponent(name)}`)
                    .then(res => {
                        if (res.data === true) {
                            var ele = document.getElementById(decodeURIComponent(name))
                            ele.remove()
                        }
                        else {
                            alert("Error deleting Brief");
                        }
                    });
            }
            catch (error) {
                console.error('Error deleting', error);
            }
        }
    };

    const handleAttachmentDelete = async (e, eventId, name) => {
        e.preventDefault()

        const confirmResult = await confirm({ title: 'Confirm', message: 'Are you sure you want to delete this attachment?' });
        if (confirmResult) {
            try {
                await axios.delete(`${EVENT_ATTACHMENTS_URL}/${eventId}/${encodeURIComponent(name)}`)
                    .then(res => {
                        if (res.data === true) {
                            var ele = document.getElementById(decodeURIComponent(name))
                            ele.remove()
                        }
                        else {
                            alert("Error deleting Attachment");
                        }
                    })
            } catch (error) {
                console.error('Error deleting', error);
            }
        }
    };

    const statusHiglight = (status) => {
        var eventStatusTab = document.getElementById("eventStatusTab");
        if (eventStatusTab == null) {
            return;
        }

        var ele = eventStatusTab.childNodes;
        ele.forEach(element => {
            element.className = "btn-custom btn btn-default"
        });

        switch (status) {
            case "Draft":
                document.getElementById("Draft").className = "btn-custom btn btn-default selectbreadcrumb"
                break;
            case "Under review":
                document.getElementById("UnderReview").className = "btn-custom btn btn-default selectbreadcrumb"
                break;
            case "Open event":
                document.getElementById("OpenEvent").className = "btn-custom btn btn-default selectbreadcrumb"
                break;
            case "Attendance confirmed":
                document.getElementById("AttendanceConfirmed").className = "btn-custom btn btn-default selectbreadcrumb"
                break;
            case "Pending documentation":
                document.getElementById("PendingDocumentation").className = "btn-custom btn btn-default selectbreadcrumb"
                break;
            case "Completed":
                document.getElementById("Completed").className = "btn-custom btn btn-default selectbreadcrumb"
                break;
            case "Rejected":
                if (document.getElementById("Rejected")) document.getElementById("Rejected").className = "btn-custom btn btn-default selectbreadcrumb"
                break;
            case "Cancelled":
                if (document.getElementById("Cancelled")) document.getElementById("Cancelled").className = "btn-custom btn btn-default selectbreadcrumb"
                break;
            default:
                document.getElementById("Draft").className = "btn-custom btn btn-default selectbreadcrumb"
        }
    }

    const onScheduleLoad = async () => {
        axios.get(`${EVENT_BRIEFS_URL}/${eventFormData.eventId}`)
            .then(async response => {
                if (response.data != null && response.data.length != 0) {
                    setBriefs(response.data);
                }
            })
            .catch(error => {
                console.error('Error fetching briefs', error);
            });

        axios.get(`${EVENT_ATTACHMENTS_URL}/${eventFormData.eventId}`)
            .then(response => {
                if (response.data != null && response.data.length != 0) {
                    setAttachments(response.data);
                }
            })
            .catch(error => {
                console.error('Error fetching attachments', error);
            });
    }

    const [headerRefresh, setHeaderRefresh] = useState(false);
    const refreshNotifications = () => {
        setHeaderRefresh(!headerRefresh);
    }

    const addComments = async (comment, isHistory) => {
        if (eventFormData.eventId !== 0) {
            let briefData = new FormData();
            briefData.append("EventId", eventFormData.eventId);
            briefData.append("Comments", comment);

            axios.post(ADD_COMMENTS_URL, briefData)
                .then(response => {
                    if (response.data != null) {
                        alert("Comment added");
                        refreshNotifications();
                        if (isHistory)
                            createHistoryElements(response.data.comments, response.data.date, response.data.user, response.data.userRole, true);
                    }
                    else
                        alert("Error adding comments");
                })
                .catch(error => {
                    console.error('Error updating the details: ', error);
                    alert("Error adding comments");
                });
        }
    }

    const addCommentsEventSection = () => { addComments(comments.EventSection, false) }
    const addCommentsDraftSection = () => { addComments(comments.DraftSection, false) }
    const addCommentsVisitSection = () => { addComments(comments.VisitSection, false) }
    const addCommentsBriefSection = () => { addComments(comments.BriefSection, false) }
    const addCommentsAttachmentSection = () => { addComments(comments.AttachmentSection, false) }
    const addCommentsHistorySection = () => { addComments(comments.HistorySection, true) }

    const setRejectEventPage = () => {
        var saveChanges = document.getElementById("rejectEvent")
        var sendValidation = document.getElementById("editEvent")
        var closeEdit = document.getElementById("ValidateOpen")
        var deleteDraft = document.getElementById("ReturnToRequestor")
        if (saveChanges) saveChanges.hidden = true
        if (sendValidation) sendValidation.hidden = true
        if (closeEdit) closeEdit.hidden = true
        if (deleteDraft) deleteDraft.hidden = true
    }

    const RejectEvent = (comment) => {
        if (eventFormData.eventId !== 0) {
            var data = new FormData();
            data.append("comments", comment)

            axios.post(`${REJECT_REQUEST}/${eventFormData.eventId}`, data)
                .then(response => {
                    if (response.data > 0) {
                        setIsRejected(true)
                        setRejectEventPage()
                        navigate(`/AppAdmin`);
                    }
                    else if (response.data == -1)
                        alert("Already sent for Rejection");
                    else if (response.data == -2)
                        alert("Not allowed to Reject");
                });
        }
    };

    const SendToRequestor = async (comment) => {
        if (eventFormData.eventId !== 0) {
            try {
                // Call the SendToRequestor API
                const data = new FormData();
                data.append("comment", comment);
                const response = await axios.post(`${SEND_TO_REQUESTOR}/${eventFormData.eventId}`,data);

                if (response.data > 0) {
                    // Handle successful response
                    alert("Event sent to the requestor");
                    eventFormData.eventStatus = "Draft";
                    statusHiglight(eventFormData.eventStatus);
                } else if (response.data === -1) {
                    alert("Already returned to the requestor");
                } else if (response.data === -2) {
                    alert("Not allowed to send to the requestor");
                } else {
                    alert("Error in sending to requestor");
                }
            } catch (error) {
                console.error("Error in sending to requestor", error);
                alert("Error in sending to requestor");
            }
        } else {
            alert("No details available to send");
        }
    };

    const ValidateOpenEvent = async (sendFamilyNotifications) => {
        try {
            // Call the Validate Open Event API
            const response = await axios.post(`${VALIDATE_OPEN_EVENT}/${eventFormData.eventId}/${sendFamilyNotifications}`);

            if (response.data > 0) {
                // Handle successful response
                refreshNotifications();
                setShowModal(true);
                eventFormData.eventStatus = "Open event";
                statusHiglight(eventFormData.eventStatus);

                // Check if the "addMember" element exists and set its visibility
                const addMemberElement = document.getElementById("addMember");
                if (addMemberElement) {
                    addMemberElement.hidden = false;
                } else {
                    console.warn("Element with ID 'addMember' not found.");
                }

                setShowPopup(true);
            } else if (response.data === -1) {
                alert("Already an Open Event");
            } else if (response.data === -2) {
                alert("Not allowed to open");
            } else {
                alert("Error in sending for Open event");
            }
        } catch (error) {
            console.error("Error in sending for Open event:", error);
            alert("Error in sending for Open event:", error);
        }
    };

    // Function to mark the event as complete
    const MarkAsComplete = async () => {
        try {
            // Create a FormData object to send eventId as multipart/form-data
            const formData = new FormData();
            formData.append("eventID", eventFormData.eventId)

            // Make the POST request with multipart/form-data
            const response = await axios.post(
                `${MARK_AS_COMPLETE}/${eventFormData.eventId}`,
                formData, // Send FormData
                {
                    headers: {
                        "Content-Type": "multipart/form-data", // Ensure the correct content type
                    },
                }
            );

            // Check if the response status is 200 and data equals 1
            if (response.status === 200 && response.data === 1) {
                eventFormData.eventStatus = "Completed";
                statusHiglight(eventFormData.eventStatus);

                // Check if the "addMember" element exists and set its visibility
                const addMemberElement = document.getElementById("addMember");
                if (addMemberElement) {
                    addMemberElement.hidden = false;
                } else {
                    console.warn("Element with ID 'addMember' not found.");
                }
            } else {
                notifyError('Oops!', 'Something went wrong while marking event as complete');
            }
        } catch (error) {
            // Log and alert detailed error message
            console.error("Error marking event as complete:", error);
            notifyError('Oops!', 'Something went wrong while marking event as complete');
        }
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const ProcessEventInvitation = async (user, status, comment,emailNotifGuest,emailNotifRequestor) => {
        if (eventFormData.eventId === 0) {
            return;
        }

        if (eventFormData.eventStatus === "Under review") {
            alert("Validate and open event before processing the invites");
            return;
        }

        const data = new FormData();
        data.append("status", status);
        data.append("comment", comment);
        data.append("userId", user.id);
        data.append("emailNotifGuest", emailNotifGuest);
        data.append("emailNotifRequestor", emailNotifRequestor);

        // Choose the API endpoint based on mltEvent
        const apiEndpoint = eventFormData.mltEvent ? PROCESS_MLT_INVITATION : PROCESS_INVITATION;

        await axios.post(`${apiEndpoint}/${eventFormData.eventId}`, data)
            .then(response => {
                if (response.data) {
                    alert("Invitation " + status);
                    refreshNotifications();
                    updateGuestDetails(user, status);
                } else {
                    alert("Error in processing invitation");
                }
            })
            .catch(error => {
                console.error('Error updating the details: ', error);
                alert("Error in processing invitation");
            });

            // Adjust status if it has changed
            axios.get(`${EVENTS_BASE_URL}/${eventFormData.eventId}`).then( response2 => {
                const data = response2.data;
                if (data != null) {
                    const updatedEventFormData = { ...eventFormData };
                    updatedEventFormData.eventStatus = data.eventStatus;
                    setEventFormData(updatedEventFormData);
                }
            });
    };

    const updateGuestDetails = (user, status) => {
        guestDetails.guests.forEach(guest => {
            if (guest.id === user.id) {
                var oldStatus = guest.status;
                var valConf = guestDetails.Confirmed;
                var valUr = guestDetails.UnderReview;
                if ((status==='Confirmed') && (oldStatus!=='Confirmed')) valConf = guestDetails.Confirmed + 1;
                if ((status!=='Confirmed') && (oldStatus==='Confirmed')) valConf = guestDetails.Confirmed - 1;
                if ((status==='Under review') && (oldStatus!=='Under review')) valUr = guestDetails.UnderReview + 1;
                if ((status!=='Under review') && (oldStatus==='Under review')) valUr = guestDetails.UnderReview - 1;
                guest.status = status;
                setGuestDetails({
                    ...guestDetails,
                    Confirmed: valConf,
                    UnderReview: valUr,
                });
                document.getElementById("Declined" + guest.name).className = `btn-remove ${guest.status === 'Declined' ? 'Declined' : ''}`;
                document.getElementById("Tentative" + guest.name).className = `btn-timer ${guest.status === 'Tentative' ? 'Tentative' : ''}`;
                document.getElementById("Confirmed" + guest.name).className = `btn-confirm ${guest.status === 'Confirmed' ? 'Confirm' : ''}`;
            }
        });
    };

    const EditEvent = () => {
        if (eventFormData.eventStatus === "Open event" || eventFormData.eventStatus === "Under review") {
            setEditable(true);

            var elementArray = document.getElementsByClassName("editable")
            for (var i = 0; i < elementArray.length; i++) {
                elementArray[i].hidden = false;
            }
        }
        else {
            alert("Not allowed to edit")
        }
    };

    const onHistoryLoad = async () => {
        if (eventFormData.eventId != 0) {
            await axios.get(`${GET_HISTORY_URL}/${eventFormData.eventId}`)
                .then(response => {
                    if (response.data.length != 0) {
                        var eleh = document.getElementById("History");
                        eleh.innerHTML = "";
                        response.data.forEach(element => {
                            if (element.history != null)
                                createHistoryElements(element.history, element.date, element.user, element.userRole, false)
                            if (element.comments != null)
                                createHistoryElements(element.comments, element.date, element.user, element.userRole, true)
                        });
                    }
                })
        }
    }

    const createHistoryElements = (data, date, user, userRole, isComment) => {
        var eleh = document.getElementById("History")
        //Date Div
        var dateDiv = document.createElement("div")
        dateDiv.className = "form-group row mb-2 align-items-center"
        //date label
        var datelabel = document.createElement("label")
        datelabel.className = "custom-font col-sm-2 col-form-label"
        datelabel.innerText = new Date(date).toLocaleDateString('en-US', {timeZone: 'UTC'});
        //div user
        var userDiv = document.createElement("div")
        userDiv.className = "col-sm-2 "
        var userStrong = document.createElement("strong")
        var userInput = document.createElement("input")
        userInput.type = "text"
        userInput.className = "custom-font-lt form-control-plaintext-cus form-control-plaintext"
        userInput.value = user
        userStrong.appendChild(userInput);
        //role
        var roleInput = document.createElement("input")
        roleInput.type = "text"
        roleInput.className = "custom-font-lt form-control-plaintext-cus form-control-plaintext"
        roleInput.value = userRole
        //comments
        var commentsDiv = document.createElement("div")
        commentsDiv.className = "form-group row mb-2"
        var commentsDiv1 = document.createElement("div")
        commentsDiv1.className = "col-sm-12 "
        var commentsInput = document.createElement("div");
        commentsInput.style.whiteSpace = "pre-wrap";
        commentsInput.style.wordWrap = "break-word";
        commentsInput.className = "custom-font-lt form-control";
        commentsInput.textContent = data;
        if (isComment)
            commentsInput.className = "custom-font-lt form-control comment"
        if (eleh != null) {
            commentsDiv1.appendChild(commentsInput)
            commentsDiv.appendChild(commentsDiv1)

            userDiv.appendChild(userStrong)
            userDiv.appendChild(roleInput)

            dateDiv.appendChild(datelabel)
            dateDiv.appendChild(userDiv)
            eleh.appendChild(dateDiv)
            eleh.appendChild(commentsDiv)
        }

    }

    const getFamilyUserList = () => {
        if (eventFormData.eventId === 0) {
            return;
        }

        axios.get(FAMILY_USERS)
            .then(response => {
                if (response.data != null) {
                    setFamilyUsers(response.data)
                }
            })
            .catch(error => {
                console.error('Error updating the family user details: ', error);
            });
    };

    const getmltsuerlist = () => {
        if (eventFormData.eventId !== 0) {
            try {
                axios.get(MLT_USERS)
                    .then(response => {
                        if (response.data != null) {
                            setMLTUsers(response.data)
                        }
                    })
                    .catch(error => {
                        console.error('Error updating the family user details: ', error);
                    });
            } catch (error) {
                console.error('Error updating the family user details', error);
            }
        }
    };

    const addUser = (user,emailNotifGuest,emailNotifRequestor,initialGuestStatus) => {
        if (eventFormData.eventId === 0) {
            return;
        }

        try {
            let isPresent = false;

            if (guestDetails.guests != null) {
                guestDetails.guests.forEach(guest => {
                    if (guest.id === user.id) {
                        isPresent = true;
                    }
                });
            }

            if (isPresent) {
                alert("User already invited");
                return;
            }

            const udata = new FormData();
            udata.append("userId", user.id);
            udata.append("emailNotifGuest", emailNotifGuest);
            udata.append("emailNotifRequestor", emailNotifRequestor);
            udata.append("initialGuestStatus", initialGuestStatus);

            // Choose the API endpoint based on mltEvent
            const apiEndpoint = eventFormData.mltEvent ? ADD_MLT_USERS : ADD_USERS;

            axios.post(`${apiEndpoint}/${eventFormData.eventId}`, udata)
                .then(response => {
                    if (response.data > 0) {
                        alert(user.fullname + " added");
                        const updatedGuests = [...guestDetails.guests, { id: user.id, name: user.fullname, status: initialGuestStatus }];
                        setGuestDetails({
                            ...guestDetails,
                            guests: updatedGuests,
                            Confirmed: initialGuestStatus==='Confirmed' ? guestDetails.Confirmed + 1 : guestDetails.Confirmed,
                            UnderReview: initialGuestStatus==='Under review' ? guestDetails.UnderReview + 1 : guestDetails.UnderReview,
                        });

                        eventFormData.mltEvent
                            ? eventFormData.mlt.push(user)
                            : eventFormData.mem.push(user);

                        // Adjust status if it has changed
                        axios.get(`${EVENTS_BASE_URL}/${eventFormData.eventId}`).then( response2 => {
                            const data = response2.data;
                            if (data != null) {
                                const updatedEventFormData = { ...eventFormData };
                                updatedEventFormData.eventStatus = data.eventStatus;
                                setEventFormData(updatedEventFormData);
                            }
                        });
                    } else {
                        alert("Error in processing invitation");
                    }
                })
                .catch(error => {
                    console.error('Error updating the details: ', error);
                });

            setUser(null);
        } catch (error) {
            console.error('Error in processing invitation', error);
        }
    };


    const removeUser = (user,emailNotifGuest,emailNotifRequestor) => {
        if (eventFormData.eventId === 0) {
            return;
        }

        const oldStatus = user.status; 
        const udata = new FormData();
        udata.append("userId", user.id);
        if (!eventFormData.mltEvent) {
            udata.append("emailNotifGuest", emailNotifGuest);
            udata.append("emailNotifRequestor", emailNotifRequestor);
        }

        const apiEndpoint = eventFormData.mltEvent ? REMOVE_MLT_USERS : REMOVE_USERS;

        axios.post(`${apiEndpoint}/${eventFormData.eventId}`, udata)
            .then(response => {
                if (response.data > 0) {
                    const updatedGuests = guestDetails.guests.filter(item => item.id !== user.id);
                    setGuestDetails({
                        ...guestDetails,
                        guests: updatedGuests,
                        Confirmed: oldStatus==='Confirmed' ? guestDetails.Confirmed - 1 : guestDetails.Confirmed,
                        UnderReview: oldStatus==='Under review' ? guestDetails.UnderReview - 1 : guestDetails.UnderReview,
                    });

                    eventFormData.mltEvent
                        ? eventFormData.mlt = eventFormData.mlt.filter(guest => guest.id != user.id)
                        : eventFormData.mem = eventFormData.mem.filter(guest => guest.id != user.id)

                    // Adjust status if it has changed
                    axios.get(`${EVENTS_BASE_URL}/${eventFormData.eventId}`).then( response2 => {
                        const data = response2.data;
                        if (data != null) {
                            const updatedEventFormData = { ...eventFormData };
                            updatedEventFormData.eventStatus = data.eventStatus;
                            setEventFormData(updatedEventFormData);
                        }
                    });
                } else {
                    alert("Error: user cannot be removed");
                }
            }).catch(error => {
                alert(`Error!\n${error.response}`);
            });
    }

    const [searchAddress, setSearchAddress] = useState("");
    const [isEventOffSite, setIsEventOffSite] = useState(false);

    return (
        <FormContext.Provider value={{
            title, eventFormData, setEventFormData, handleChange, getEventById,
            handlepageChange, page, setPage, comments, setComments, addCommentsEventSection,
            addCommentsDraftSection, addCommentsVisitSection, addCommentsBriefSection, addCommentsAttachmentSection,
            addCommentsHistorySection, editable, RejectEvent, SendToRequestor, ValidateOpenEvent, MarkAsComplete, guestDetails, ProcessEventInvitation,
            EditEvent, familyUsers, setFamilyUsers, removeUser, addUser, user, setUser, showPopup, setShowPopup, handleGuestData, closeModal, showModal, showConfirmationModalEventValidation, setShowConfirmationModalEventValidation, 
            handleMLTEventChange, setMLTUsers, mltUsers, files, setFiles, hiddenUploadImageFileInput, handleUploadImageClick, handleBriefUpload,
            handleUploadBriefFileClick, hiddenUploadBriefFileInput, hiddenAttachmentFileInput, handleUploadAttachmentClick, handleAttachmentsUpload,
            handleScheduleItenaryChange, attachments, briefs, handleAttachmentDelete, handleBriefDelete, setErrors, errors, handleEmailValidation,
            searchAddress, setSearchAddress, isEventOffSite, setIsEventOffSite, statusHiglight, isCoverImageUploaded, setIsCoverImageUploaded, handleValidation,
            headerRefresh, setHeaderRefresh, refreshNotifications, modalGuest, setModalGuest,
            associateAtEvent, setassociateAtEvent, selectedAssociates, setSelectedAssociates,
            showConfirmationModalDeleteUpload, setShowConfirmationModalDeleteUpload
        }}>
            {children}
        </FormContext.Provider>
    )
}
export default FormContext 